/**
 * `useMutation` meta for a mutation whose caller shows its own error UI. Inside the CRM host the
 * remote's mutations run on the host's QueryClient, whose `MutationCache.onError` toasts every
 * failure unless `meta.suppressGlobalErrorToast` is true (crm-fe `mutationMeta.ts`); without it the
 * user sees the same error twice.
 */
export const SUPPRESS_GLOBAL_ERROR_TOAST = { suppressGlobalErrorToast: true } as const;
